import TriggerNode from "./TriggerNode"
import ConditionNode from "./ConditionNode"
import ActionNode from "./ActionNode"
import BranchNode from "./BranchNode"

export const nodeTypes = {
  trigger: TriggerNode,
  condition: ConditionNode,
  action: ActionNode,
  branch: BranchNode
}

export { TriggerNode, ConditionNode, ActionNode, BranchNode }
